import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Text,
  Image,
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CustomButton from "../customButton/CustomButton";

const CartItem = ({
  cartData,
  productQuantity,
  handleDeleteCartItem,
  handleQuantityDecrease,
  handleQuantityIncrease,
  isLoading,
}) => {
  const variantId = cartData.variants.map((item) => item.id);
  const [openModal, setOpenModal] = useState(false);
  return (
    <Flex p={1} borderBottom="1px solid #ccc" alignItems="center">
      <Box mr={4}>
        <Link to={`/productDetails/${cartData.productId}`}>
          <Image
            src={cartData.img}
            alt={cartData.productName}
            boxSize={{ base: "100px", md: "120px" }}
            borderRadius={"10px"}
          />
        </Link>
      </Box>

      <Box
        h={{ md: 150 }}
        flex="1"
        w={"100%"}
        textAlign={{ base: "justify", md: "left" }}
        mt={"6"}
      >
        <Text fontSize={{ base: "16px", md: "16px" }}>
          <strong>{cartData.productName}</strong>
        </Text>
        <Text fontSize={{ base: "12px", md: "12px" }}>
          {cartData.productDescription.slice(0, 150)}
          {cartData.productDescription.length > 20 ? "..." : ""}
        </Text>
        <Box flex="1">
          <Text fontSize={{ base: "12px", md: "13px" }}>
           Original Price:  ₹{cartData?.priceDetails.price || 0}
          </Text>
          <Text fontSize={{ base: "12px", md: "13px" }}>
            Discounted Price:  ₹{cartData?.priceDetails.sellingPrice || 0}
          </Text>

          <Text fontSize={{ base: "12px", md: "13px" }}>
            Subtotal: ₹ {cartData?.priceDetails.sellingPrice * productQuantity}
          </Text>
        </Box>

        <Box alignItems={"left"}>
          <Flex flexDirection={{ base: "column", md: "row" }} gap={3}>
            <Box mt={"2"}>
              <div className="flex justify-center items-center">
                <Button
                  background="#36BAD5"
                  borderRadius="10px 0px 0px 10px"
                  opacity="1"
                  onClick={() => {
                    if (productQuantity > 1) {
                      handleQuantityDecrease({
                        productId: cartData.productId,
                        variantId: variantId[0],
                        quantityType: "SUBSTRACT",
                      });
                    }
                    if (productQuantity === 1) {
                      setOpenModal(true);
                    }
                  }}
                  size="xs"
                  variant="outline"
                  isLoading={isLoading}
                  // isDisabled={productQuantity === 1}
                >
                  -
                </Button>
                <Text
                  textAlign={"center"}
                  fontSize={{ base: "10px", md: "13px" }}
                  px={"1"}
                >
                  {productQuantity}
                </Text>
                <Button
                  background="#36BAD5"
                  borderRadius="0px 10px 10px 0px"
                  opacity="1"
                  onClick={() => {
                    if (productQuantity <= 5) {
                      handleQuantityIncrease({
                        productId: cartData.productId,
                        variantId: variantId[0],
                        quantityType: "ADD",
                      });
                    }
                  }}
                  size="xs"
                  variant="outline"
                  isDisabled={productQuantity >= 5}
                  isLoading={isLoading}
                >
                  +
                </Button>
              </div>
            </Box>
            {/* <Button
              fontSize={"12px"}
              bgColor={"white"}
              cursor="pointer"
              color="blue"
            >
              Save To Wishlist
            </Button> */}
            {/* {productQuantity === 1 && (
              <CustomButton
                size="small"
                variant="ghost"
                className="mt-1 !border-red-400 !text-red-400 hover:bg-red-50"
                onClick={() => {
                  handleDeleteCartItem({
                    productId: cartData.productId,
                    variantId: variantId[0],
                    quantityType: "SUBSTRACT",
                  });
                }}
              >
                Remove Item
              </CustomButton>
            )} */}
          </Flex>
        </Box>
      </Box>
      {/* Open Modal for confirming remove item */}
      <Modal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Would you like to remove this item?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              <div className="flex gap-3 ">
                <div>
                  <img
                    src={cartData.img}
                    alt={cartData.productName}
                    className="max-w-[80px] rounded-lg"
                  />
                </div>
                <div>
                  <div className="text-base font-semibold">
                    {cartData.productName}
                  </div>
                  <div className="text-sm">
                    {cartData.productDescription.slice(0, 80)}
                    {cartData.productDescription.length > 20 ? "..." : ""}
                  </div>
                  <div>
                    <div className="text-base">
                      Price: ₹ {cartData?.priceDetails.sellingPrice || 0}{" "}
                    </div>

                    <div className="text-base">
                      Subtotal: ₹{" "}
                      {cartData?.priceDetails.sellingPrice * productQuantity}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <CustomButton
              className="bg-red-500 hover:bg-red-600"
              onClick={() => {
                handleDeleteCartItem({
                  productId: cartData.productId,
                  variantId: variantId[0],
                  quantityType: "SUBSTRACT",
                });
              }}
            >
              Confirm
            </CustomButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default CartItem;
